

























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { DateTextLayer } from "@/model/document2/page/surface/design/layer/dateTextLayer";
import { MathHelper } from '@/helper/mathHelper';

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class TextSpacingController extends Vue 
{
    @Prop() layer! : DateTextLayer;

    private getTextInfo(name : string)
    {
        return this.layer.textInfo[name];
    }

    private get letterSpacing()
    {
        var value = this.getTextInfo("letterSpacing");
        return value != null ? MathHelper.clamp(value, -25, 25) : 0;
    }

    private set letterSpacing(letterSpacing)
    {
        this.changeTextInfo("letterSpacing", Number(letterSpacing), false, false);
    }

    private get letterSpacingText()
    {
        return this.letterSpacing.toFixed(1) + "pt";
    }

    private onLetterSpacingChanged()
    {
        this.changeTextInfo("letterSpacing", this.letterSpacing, true, false);
    }

    private get lineSpacing()
    {
        return Math.min(this.layer.lineSpacing, 300);
    }

    private set lineSpacing(lineSpacing : number)
    {
        this.changeLayerProperty("lineSpacing", Number(lineSpacing), false, false);
    }

    private get lineSpacingText()
    {
        return this.lineSpacing.toFixed() + "%";
    }

    private onLineSpacingChanged()
    {
        this.changeTextInfo("lineSpacing", this.lineSpacing, true, false);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }

    private changeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeTextInfo", propertyName, value, isFinish, isOnce);
    }
}
